<div>

  <form [formGroup]="formService.form" (ngSubmit)="onSubmit(formService.form.value)">

    <div class="form-group">
      <label for="name" i18n="@@RfidTagLabel" >Herstellername</label>
      <input type="text" id="name" formControlName="name" class="form-control" i18n-placeholder="@@ManufacturerNamePlaceholder" placeholder="Herstellername" />

      <div class="error">
        <em *ngIf="formService.validateControl('name') && formService.hasError('name', 'required')" i18n="@@RManufacturerNameRequiredErrorMessage">Herstellername wird benötigt</em>
      </div>
    </div>

  </form>
</div>
